import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import {titleCaseWord} from '../util';
import WordFilterMenu from './WordFilterMenu';
import {LETTER_COMBINATION_GROUP_SUBTITLES} from '../data/words';

import filterBtnImg from '../images/btn-filter.svg';

class ProductHeader extends Component {
  state = {
    wordFilterMenuOpen: false,
    filterMenuAnchorEl: null,
  };

  getStepName() {
    const {activeStep} = this.props;
    let stepName = activeStep;

    if (activeStep === 'WORDS') {
      stepName = 'Words';
    }

    return stepName;
  }

  formatLabel(value) {
    return value.toLowerCase().split('_').map(titleCaseWord).join(' ');
  }

  getStepFilters() {
    const filters = this.props.filters;
    const activeStep = this.props.activeStep;
    let activeStepFilters = [];

    const makeFilterObj = (product, attr, value, label = `${value}`) => {
      return {
        product,
        attr,
        value,
        label, //: this.formatLabel(label),
      };
    };

    if (activeStep === 'WORDS') {
      const patternFilters = filters.words.pattern.map((pattern) =>
        makeFilterObj('words', 'pattern', pattern, LETTER_COMBINATION_GROUP_SUBTITLES[pattern]),
      );

      activeStepFilters = activeStepFilters.concat(patternFilters);
    }

    return activeStepFilters;
  }

  handleClickFilter = (...args) => {
    const activeStep = this.props.activeStep;

    if (activeStep === 'WORDS') {
      this.handleClickWordFilter(...args);
    }
  };

  // Words
  handleClickWordFilter(event) {
    this.setState({
      wordFilterMenuOpen: true,
      filterMenuAnchorEl: event.currentTarget,
    });
  }

  handleClickFilterWordPattern = (pattern) => {
    this.setState({
      wordFilterMenuOpen: false,
    });

    this.props.setFilter('words', 'pattern', [pattern]);
  };

  renderStepFilter = (filter, key) => {
    return (
      <div className="product-header-filter" key={key}>
        <Chip onDelete={() => this.props.removeFilter(filter)} label={filter.label} />
      </div>
    );
  };

  render() {
    const stepName = this.getStepName();
    const stepFilters = this.getStepFilters();

    return (
      <div className="product-header">
        <h3 className="product-header-title">{stepName}</h3>
        <div className="product-header-filters">
          {stepFilters.map(this.renderStepFilter)}
          <img className="product-header-filter-btn" src={filterBtnImg} alt="filter" onClick={this.handleClickFilter} />
        </div>

        <WordFilterMenu
          open={this.state.wordFilterMenuOpen}
          anchorEl={this.state.filterMenuAnchorEl}
          handleRequestClose={() => this.setState({wordFilterMenuOpen: false})}
          handleClickFilterWordPattern={this.handleClickFilterWordPattern}
        />
      </div>
    );
  }
}

ProductHeader.propTypes = {
  filters: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  activeStep: PropTypes.string.isRequired,
};

export default ProductHeader;
